// Utilities to clone props with type safety in mind
export const clonePropTypes = component => Object.assign({}, component.propTypes);
export const cloneDefaultProps = component => Object.assign({}, component.defaultProps);